<!-- 滚动盒子 -->
<template>
    <swiper class="scrollBox" :options="swiperOption" ref="swiperList">
        <!-- slides -->
        <swiper-slide>
            <slot name="main"></slot>
        </swiper-slide>
    </swiper>
</template>

<script>
import { swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
    data() {
        return {
            swiperOption: {
                direction: 'vertical',
                slidesPerView: 'auto',
                mousewheel: true,
                freeMode: true,
                resistanceRatio : 0,//让slide在边缘不能被拖动
                // loop : true,
                
            },
        }
    },
    props:{
        showData:{
            type:Array,
            default(){
                return [];
            }
        },
        autoplay:{
            type:Boolean,
            default(){
                return true;
            }
        },
        num:{
            default(){
                return '';
            }
        }
    },
    components:{
        swiper,
        swiperSlide
    },
    created() {
        if(this.autoplay){
            let speed = 20000;
            if(this.num){
                speed = 1000 * this.num
            }
            let autoParam = {
                autoplay: {
                    delay:0,
                    disableOnInteraction: false,//操作后是否停止轮播
                    stopOnLastSlide: true,
                },
                speed:speed,//滚动速度
            }
            this.swiperOption={...this.swiperOption,...autoParam}
        }
    },
}
</script>

<style lang="scss" scoped>
.scrollBox{
    width:100%;
    height: 100%;
    .swiper-slide{
        height: auto;
    }
}
</style>
